package horcrux.frontend.common.views.components.containers

import horcrux.frontend.common.BooleanState
import horcrux.frontend.common.views.components.loading.LoadingButton
import horcrux.frontend.common.withDefaultCSS
import mui.material.Button
import mui.material.Dialog
import mui.material.DialogActions
import mui.material.DialogContent
import mui.material.IconButton
import mui.system.PropsWithSx
import mui.system.sx
import react.FC
import react.PropsWithChildren
import react.ReactNode

typealias DialogIsOpenState = BooleanState
typealias DialogButtonIsLoadingState = BooleanState

sealed interface IDialogAction

data class DialogAction(
    val buttonLabel: String,
    val onButtonClickMaybe: ((DialogIsOpenState, DialogButtonIsLoadingState) -> Unit)? = null,
) : IDialogAction

data class DialogActionView(
    val view: ReactNode,
    val onViewClickMaybe: ((DialogIsOpenState) -> Unit)? = null,
) : IDialogAction

external interface DialogViewProps : PropsWithChildren, PropsWithSx {
    var showDialogState: BooleanState
    var title: String
    var onCloseMaybe: (() -> Unit)?
    var dialogActionsMaybe: List<IDialogAction>?
}

val DialogView = FC<DialogViewProps> { props ->
    Dialog {
        this.title = props.title
        this.open = props.showDialogState.get()
        this.onClose = { _, _ ->
            props.onCloseMaybe?.invoke()
            props.showDialogState.setFalse()
        }
        this.sx { +props.sx }
        DialogContent {
            this.withDefaultCSS()
            +props.children
        }
        DialogActions {
            props.dialogActionsMaybe?.let { dialogActions ->
                dialogActions.forEach { dialogAction ->
                    when (dialogAction) {
                        is DialogAction -> LoadingButton {
                            +dialogAction.buttonLabel
                            this.onClick = { isLoadingState ->
                                dialogAction.onButtonClickMaybe?.invoke(props.showDialogState, isLoadingState)
                                    ?: run { props.showDialogState.setFalse() }
                            }
                        }

                        is DialogActionView -> IconButton {
                            +dialogAction.view
                            this.onClick = {
                                dialogAction.onViewClickMaybe?.invoke(props.showDialogState)
                                    ?: run { props.showDialogState.setFalse() }
                            }
                        }
                    }
                }
            } ?: run {
                Button {
                    +"OK"
                    this.onClick = { props.showDialogState.setFalse() }
                }
            }
        }
    }
}
